export default __webpack_public_path__ + "partner_9d8da11.png";